import request from '@/utils/request'

let CustomerApi = {
    /*  客户详细信息 */
    getCustomerData(data, errorback) {
        return request._post('/shop/plus.customer.customer/getCustomerData', data, errorback);
    },
    /* 客户资源列表 */
    customerList(data, errorback) {
        return request._post('/shop/plus.customer.customer/customerList', data, errorback);
    },
    /* 省列表 */
    provinceList(data, errorback) {
        return request._get('/shop/plus.customer.customer/provinceList', data, errorback);
    },
    /* 市列表 */
    city_list(data, errorback) {
        return request._get('/shop/plus.customer.customer/cityList', data, errorback);
    },
    /* 区域列表 */
    region_list(data, errorback) {
        return request._get('/shop/plus.customer.customer/regionList', data, errorback);
    },
    /* 保存编辑客户资源 */
    get_edit(data, errorback) {
        return request._post('/shop/plus.customer.customer/getEdit', data, errorback);
    },
    /* 删除客户资源 */
    del_customer(data, errorback) {
        return request._post('/shop/plus.customer.customer/delCustomer', data, errorback);
    },
    /* 保存客户配置 */
    put_setting(data, errorback) {
        return request._post('/shop/plus.customer.customer/putSetting', data, errorback);
    },
    /* 获取客户配置 */
    get_setting(data, errorback) {
        return request._post('/shop/plus.customer.customer/getSetting', data, errorback);
    },
    /* 保存自定义配置 */
    put_open(data, errorback) {
        return request._post('/shop/plus.customer.customer/putOpen', data, errorback);
    },
    /* 获取自定义配置 */
    get_open(data, errorback) {
        return request._get('/shop/plus.customer.customer/getOpen', data, errorback);
    },

    /* 获取会员等级 */
    user_list(data, errorback) {
        return request._get('/shop/plus.customer.customer/getUserList', data, errorback);
    },

    /* 获取会员 */
    get_bind(data, errorback) {
        return request._post('/shop/plus.customer.customer/getBind', data, errorback);
    },

    /* 上传文件  */
    get_upload(formData, errorback) {
        return request._upload('/shop/plus.customer.customer/excel_upload', formData, errorback);
    },

    /* 获取后台域名 */
    uploadUrl(data, errorback) {
        return request._get('/shop/plus.customer.customer/upload_url', data, errorback);
    },

}
export default CustomerApi;


// WEBPACK FOOTER //
// ./src/api/customer.js